const translations = {
  // Header / view badges
  prologueResults: 'PROLOGUE RESULTS',
  startPositionSelection: 'START POSITION SELECTION',
  appTitle: 'START ORDER PICKER APPLICATION',
  pickOrder: 'Pick Order',
  poweredBy: 'Powered by',

  // Toolbar tooltips
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  configuration: 'Configuration',
  connectingZigbee: 'Connecting…',
  disconnectZigbee: 'Disconnect Zigbee',
  connectZigbee: 'Connect Zigbee',
  zigbeeConnectError: 'Wireless zigbee receptor connection failed',
  zigbeeConnected: 'Wireless zigbee receptor connected successfully.',
  zigbeeDeviceNotPaired: 'Remote is not paired. Press and hold the UP button for 10 seconds until the LED blinks. When the light stays steady, the remote is paired. Time left to pair:',
  zigbeeDevicePaired: 'Remote paired successfully and joined the network.',
  zigbeePortInUse: 'Serial port is already in use. Close any other application using it and try again.',
  exitEditMode: 'Exit edit mode',
  editParticipants: 'Edit participants',
  reset: 'Reset',
  switchToPrologue: 'Switch to Prologue Results',
  switchToStart: 'Switch to Start Position Selection',
  stopSession: 'Stop session',
  startSession: 'Start session',
  sessionStarted: 'Start position session started. Pilots, choose your start position!',
  loadFromAnube: 'Import from Anube',
  addParticipant: 'Add participant',

  // Session warning dialog
  startNewSession: 'Start New Session',
  sessionWarningBody: 'There are already started positions. Start a new session from scratch or continue the current one?',
  newSession: 'New Session',
  continueSession: 'Continue',

  // DialogConfirm defaults
  resetTitle: 'Reset Start Order',
  resetBody: 'All participants and session data will be permanently deleted.',
  resetConfirm: 'Delete All',
  warningCannotBeUndone: 'This action cannot be undone.',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // AddParticipantModal / EditParticipantModal shared
  brand: 'Brand',
  driver: 'Driver',
  driverNamePlaceholder: 'Driver name',
  coDriver: 'Co-Driver',
  coDriverNamePlaceholder: 'Co-Driver name',
  team: 'Team',
  teamNamePlaceholder: 'Team name',
  allowChooseStart: 'Allow choose start position',
  priorityPilot: 'Priority pilot',
  timeSec: 'Time (sec)',

  // AddParticipantModal
  addParticipantTitle: 'Add Participant',
  add: 'Add',

  // EditParticipantModal
  editParticipantTitle: 'Edit Participant',
  save: 'Save',

  // ConfigModal
  configTitle: 'Configuration',
  eventName: 'Event name',
  showTime: 'Show participant time',
  showCodriver: 'Show co-driver',
  showTeam: 'Show team',
  allParticipantsVisible: 'All participants visible before picking',
  language: 'Language',
  close: 'Close',

  // RaceConfigModal
  loadFromAnubeTitle: 'Import from Anube',
  raceNumber: 'Race number',
  raceNumberPlaceholder: 'e.g. 305',
  loading: 'Loading…',
  load: 'Load',
  loadError: 'Failed to load. Check the race number.',
  itinerary: 'Itinerary',
  specialStage: 'Special / Stage',
  applyAndFetch: 'Apply & Fetch',

  // Priority pilots field
  priorityPilotsLabel: 'Priority pilots (by number)',
  priorityPilotsPlaceholder: 'e.g. 201, 37, 5',
  priorityPilotsHint: 'Comma-separated list of vehicle numbers that will be marked as priority pilots.',

  // Max participants
  maxParticipantsLabel: 'Participants to import',

  // FIA Rules
  useFiaRules: 'Use FIA Rules Section 33.1.1',
};

export default translations;
